module.exports = __webpack_public_path__ + "img/DIS-Logo.c4785673.png";